import { NgModule, Provider } from '@angular/core';

import { nbaConditionResolverToken } from './nba-condition-resolver.token';
import { NbaConditionResolversCollection } from './nba-condition-resolvers-collection';
import * as resolvers from './types/index';

const providers: Provider[] = [NbaConditionResolversCollection];

for (const key of Object.keys(resolvers) as (keyof typeof resolvers)[]) {
  providers.push({
    provide: nbaConditionResolverToken,
    multi: true,
    useClass: resolvers[key]
  });
}

@NgModule({
  providers
})
export class NbaConditionResolversModule {}
